import { createStore, applyMiddleware, compose } from "redux";
import { connectRouter, routerMiddleware } from "connected-react-router";
import axios from "axios";
import axiosMiddleware from "redux-axios-middleware";
import thunk from "redux-thunk";
import { createBrowserHistory } from "history";
import createRootReducer from "../reducers";
import { handleExpiredTokens } from "../middleware/sessionTokenFallback";
import { handleForbiddenRequests } from "../middleware/forbiddenRequestHandling";
import { handleUnconfirmedUsers } from "../middleware/confirmationMiddleware";
import { tokenRefresh } from "../middleware/sessionTokenRefreshing";
import { addFlashes } from "../middleware/flashes";
import { multiClientHandler } from "../middleware/multiClientHandler";
import { customErrorMessage } from "../middleware/customErrorMessage";
// import { composeWithDevTools } from 'redux-devtools-extension'

export const history = createBrowserHistory();

const initialState = {};

const enhancers = [];

const middleware = [
  thunk,
  routerMiddleware(history),
  tokenRefresh,
  multiClientHandler,
  axiosMiddleware(axios, {
    // Use the global axios instance
    returnRejectedPromiseOnError: true,
  }),
  handleExpiredTokens,
  handleUnconfirmedUsers,
  handleForbiddenRequests,
  customErrorMessage, //Intercept failed api responses to flash a non generic message
  addFlashes,
];

if (process.env.NODE_ENV === "development") {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

  if (typeof devToolsExtension === "function") {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const store = createStore(
  createRootReducer(history),
  initialState,
  composedEnhancers
);

export default store;
